import React, {
  Fragment,
  useContext,
  useState,
  useRef,
  useEffect,
} from "react";
import {
  Paper,
  Button,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  MenuItem,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowDropDownRoundedIcon from "@material-ui/icons/ArrowDropDownRounded";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";
import FacebookCampaignContext from "../../../../context/facebook_profiles/campaign/CampaignContext";
import FacebookAdSetContext from "../../../../context/facebook_profiles/adset/AdSetContext";
import FacebookAdContext from "../../../../context/facebook_profiles/ad/AdContext";

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
    marginLeft: "1rem",
    width: "12rem",
  },
  header1: {
    zIndex: theme.zIndex.mobileStepper,
  },
}));

const DashboardStats_01_Delivery = () => {
  const classes = useStyles();

  const { stats_delivery_filter, setStatsFilter, current_tab } = useContext(
    FacebookProfilesDashboardContext
  );
  const CampaignContext = useContext(FacebookCampaignContext);
  const AdSetContext = useContext(FacebookAdSetContext);
  const AdContext = useContext(FacebookAdContext);

  const [status, setStatus] = useState([]);
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (e) => {
    if (anchorRef.current && anchorRef.current.contains(e.target)) {
      return;
    }

    setOpen(false);
  };

  const handleListKeyDown = (e) => {
    if (e.key === "Tab") {
      e.preventDefault();
      setOpen(false);
    }
  };

  const handleSelect = (e) => {
    setStatsFilter("stats_delivery_filter", {
      current_tab,
      status: e.target.id,
    });
    handleClose(e);
  };

  useEffect(() => {
    if (current_tab === "Campaign") {
      setStatus(CampaignContext.list_delivery);
    } else if (current_tab === "Ad Set") {
      setStatus(AdSetContext.list_delivery);
    } else if (current_tab === "Ad") {
      setStatus(AdContext.list_delivery);
    }
  }, [current_tab]);

  return (
    <Fragment>
      <Button
        variant="outlined"
        color="primary"
        className={classes.button}
        ref={anchorRef}
        aria-controls={open ? "stats_delivery_filter" : undefined}
        aria-haspopup={true}
        onClick={handleToggle}
      >
        {stats_delivery_filter[current_tab]} <ArrowDropDownRoundedIcon />
      </Button>
      <Popper
        transition
        role={undefined}
        anchorEl={anchorRef.current}
        open={open}
        className={classes.header1}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement,
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  id="stats_delivery_filter"
                  autoFocusItem={open}
                  onKeyDown={handleListKeyDown}
                >
                  {status.map((each) => {
                    return (
                      <MenuItem key={each} id={each} onClick={handleSelect}>
                        {" "}
                        {each}{" "}
                      </MenuItem>
                    );
                  })}{" "}
                </MenuList>{" "}
              </ClickAwayListener>{" "}
            </Paper>{" "}
          </Grow>
        )}{" "}
      </Popper>{" "}
    </Fragment>
  );
};

export default DashboardStats_01_Delivery;
